"use strict";
// There are 3rd party types for CSS that make sure when we define styles, we're using valid things....
// like { color: 'red' } is ok but { potato: 'foo' } is not. Unfortunately, this library doesn't support
// the valid css keys like { --act-name: 'Missing Fence' } (to declare/css vars) or the derefernencing them
// like { content: var(--act-name) }. Supposedly this is coming in 3.1 but in the meantime, we're extending these
// types here
//     (see https://github.com/frenic/csstype/issues/126 for more info)
Object.defineProperty(exports, "__esModule", { value: true });
